import { http } from '../utils/http';
import qs from 'qs';

export const getTransmissionReportApi = async (data) => {
  try {
    const res = await http.get('/Reports/get-transmission-report', {
      params: data,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
    return res;
  } catch (error) {}
};

export const getAlarmStatusReportApi = async (data) => {
  try {
    const res = await http.get('/Reports/get-alarm-status-report', {
      params: data,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
    return res;
  } catch (error) {}
};

export const getDashboardReportReportApi = async (data) => {
  try {
    const res = await http.get('/Dashboard', {
      params: data,
      paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat' }),
    });
    return res;
  } catch (error) {}
};
export const getMeterMonthlyReportReportApi = async (data) => {
  try {
    const res = await http.get('/Reports/get-meter-monthly-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};

export const getMeterUsageReportApi = async (data) => {
  try {
    const res = await http.get('/Reports/get-meter-usage-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};

export const getMeterDailyUsageReportApi = async (data) => {
  try {
    const res = await http.get('/Reports/get-meter-daily-usage-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};

export const ActivePremiseExcelDownload = async (data) => {
  try {
    const res = await http.get('/Reports/get-all-transmission-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};

export const AlarmManagementExcelDownload = async (data) => {
  try {
    const res = await http.get('/Reports/get-all-alarm-status-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};

export const getMeterUsageReportExcelDownload = async (data) => {
  try {
    const res = await http.get('/Reports/get-meter-usage-all-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};

export const getMeterDailyUsageReportExcelDownload = async (data) => {
  try {
    const res = await http.get('/Reports/get-meter-daily-usage-all-report', {
      params: data,
    });
    return res;
  } catch (error) {}
};
